webpackJsonp([40589038282886],{

/***/ 1254:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ImportEntityType","kind":"ENUM","type":"OBJECT","fields":null,"description":"Type of entity being imported from a patient document","enumValues":[{"deprecationReason":null,"description":"Import an immunization","isDeprecated":false,"name":"IMMUNIZATION"},{"deprecationReason":null,"description":"Import a medication","isDeprecated":false,"name":"MEDICATION"},{"deprecationReason":null,"description":"Import a patient protocol","isDeprecated":false,"name":"PATIENT_PROTOCOL"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-import-entity-type-157dade0021068787dc5.js